// Types whose dashboard URLs carry no parent/subgroup chain (just `/type/name`).
// Callers with per-group config (e.g. `needsSchemaSetters` in uiConfig.json)
// should pass their own set; this is only the fallback for untyped callers.
export const DEFAULT_FLAT_TYPES = new Set(['complexDataType']);

function decodePathSegment(segment) {
  try {
    return decodeURIComponent(segment);
  } catch {
    return null;
  }
}

export function parseDashboardSchemaPath(dashboardPath, flatTypes = DEFAULT_FLAT_TYPES) {
  if (typeof dashboardPath !== 'string') return null;

  const path = dashboardPath.split(/[?#]/, 1)[0].replace(/^\/dashboard\/?/, '');
  const encodedSegments = path.split('/').filter(Boolean);
  if (encodedSegments.length < 3) return null;

  const segments = encodedSegments.map(decodePathSegment);
  if (segments.some((segment) => segment == null)) return null;

  const type = segments[1];
  if (!type) return null;

  return {
    type,
    name: segments[segments.length - 1],
    parent: flatTypes.has(type) ? '' : segments.slice(2, -1).join('/'),
  };
}

export function findSchemaItemFromDashboardPath(items, dashboardPath, flatTypes = DEFAULT_FLAT_TYPES) {
  if (!Array.isArray(items) || items.length === 0) return null;

  const target = parseDashboardSchemaPath(dashboardPath, flatTypes);
  if (!target) return null;

  const matchingItems = items.filter(
    (item) => item?.type === target.type && item?.name === target.name
  );

  if (flatTypes.has(target.type)) {
    return matchingItems.length === 1 ? matchingItems[0] : null;
  }

  return matchingItems.find((item) => (item.parent || '') === target.parent) || null;
}

export function findSchemaItem(items, selection) {
  if (!Array.isArray(items) || !selection || typeof selection !== 'object') return null;
  if (typeof selection.type !== 'string' || !selection.type || typeof selection.name !== 'string') {
    return null;
  }

  return (
    items.find(
      (item) =>
        item?.type === selection.type &&
        item?.name === selection.name &&
        (item?.parent || '') === (selection.parent || '')
    ) || null
  );
}
